import { render, staticRenderFns } from "./ApplicationRecovery.vue?vue&type=template&id=8e8f1004&scoped=true&"
import script from "./ApplicationRecovery.vue?vue&type=script&lang=js&"
export * from "./ApplicationRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8f1004",
  null
  
)

export default component.exports